import Vue from 'vue'
import SvgIcon from '../../components/svgIcon' // svg component

// register globally
Vue.component('svg-icon', SvgIcon)

// 加载通用 svg 图标
const req = require.context('@/assets/svg', false, /\.svg$/)
const requireAll = (requireContext) => {
  // requireContext.keys()数据：['./404.svg', './agency.svg', './det.svg', './user.svg']
  requireContext.keys().map(requireContext)
}
requireAll(req)

// 加载车辆图标 svg 文件
const reqIconSvg = require.context('@/assets/icon-svg', false, /\.svg$/)
requireAll(reqIconSvg)
